var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckinEarly = function SvgCheckinEarly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M11.958 9.667h-.209a3.751 3.751 0 0 0-3.541-3.74V5.5h.416a.208.208 0 0 0 0-.417h-1.25a.208.208 0 0 0 0 .417h.417v.427a3.751 3.751 0 0 0-3.542 3.74h-.208a.625.625 0 1 0 0 1.25h7.917a.625.625 0 0 0 0-1.25ZM7.999 6.333a3.337 3.337 0 0 1 3.334 3.334H4.666a3.337 3.337 0 0 1 3.333-3.334Zm3.959 4.167H4.04a.208.208 0 1 1 0-.417h7.917a.208.208 0 1 1 0 .417Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M7.374 7.166a1.5 1.5 0 0 0-1.447.976.208.208 0 1 0 .395.132c.182-.545.747-.69 1.052-.69a.208.208 0 0 0 0-.418Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    fillRule: "evenodd",
    d: "M8 15.57A7.57 7.57 0 1 0 8 .43a7.57 7.57 0 0 0 0 15.14ZM8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckinEarly;